import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f795730e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rounded-full border-2",
  style: {"border-color":"#1fa248"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex-1 flex flex-wrap" }
const _hoisted_4 = { class: "w-full lg:w-auto font-semibold text-2xl px-6" }
const _hoisted_5 = { class: "w-full lg:w-auto ml-auto text-xl px-6 pt-6" }
const _hoisted_6 = { class: "w-full lg:w-auto mt-4 flex justify-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Receive ")
const _hoisted_8 = { class: "sm:flex justify-center lg:justify-between sm:space-x-4 mb-14 mt-6 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center lg:text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-info mt-4" }, " Over 1 year: * refers to the calculation of last year's value "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-info" }, " Less than 1 year: * estimation of the amount to be earned ")
], -1))
const _hoisted_10 = { class: "flex justify-center lg:justify-end mt-5 sm:mt-0" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Receive All ")
const _hoisted_12 = { class: "text-xl text-center mb-8" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" In case you were wondering what is Carbon Token and Life Token. You may ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("click here.")
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-description font-medium mb-6" }, " Follow us to for more updates at ", -1))
const _hoisted_17 = { class: "flex space-x-10 justify-center items-center" }
const _hoisted_18 = {
  target: "_blank",
  href: "https://web.facebook.com/Bringbacktheforest?_rdc=1&_rdr"
}
const _hoisted_19 = {
  target: "_blank",
  href: "https://twitter.com/bbtfbbtf?s=21"
}
const _hoisted_20 = {
  target: "_blank",
  href: "https://www.youtube.com/channel/UCgexR3KciJ3ZWsBOqV28HQA"
}
const _hoisted_21 = {
  target: "_blank",
  href: "https://www.instagram.com/bringbacktheforestbbtf/?igshid=YmMyMTA2M2Y%3D"
}
const _hoisted_22 = {
  target: "_blank",
  href: "https://www.tiktok.com/@bringbacktheforest"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Confirmation")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" You are about to claim ")
const _hoisted_25 = { class: "font-medium text-primary opacity-85" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(". Please press the confirm button to proceed. ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Claimed")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Your claimed tokens are now sending to your wallet", -1))

import { useSmartContract } from '@/composables/useSmartContract';
import useToastMessage from '@/composables/useToastMessage';
import { useUserStore } from '@/store/user';
import { MoralisKey } from '@/symbols/moralis';
import Moralis from 'moralis';
import { computed, inject, reactive, ref, watch } from 'vue';
import * as apis from '@/apis';
import { BIODIVERSITY_NFT_ADDRESS, CARBON_NFT_ADDRESS } from '@/constants';
import IconFacebook from '@/components/Icons/IconFacebook.vue';
import IconTwitter from '@/components/Icons/IconTwitter.vue';
import IconYouTube from '@/components/Icons/IconYouTube.vue';
import IconTiktok from '@/components/Icons/IconTiktok.vue';
import IconIg from '@/components/Icons/IconIg.vue';
import Web3 from 'web3';

type Tokens = [number | string, number | string];
interface Claimables {
  tokenAddress?: string;
  total?: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const NONE_SELECTED = -1;
const ALL_SELECTED = 0;
const CARBON_SELECTED = 1;
const BIO_SELECTED = 2;
const ZERO = '0';

const moralis = inject(MoralisKey, Moralis);
const smartContract = useSmartContract();
const { error: showError } = useToastMessage();
const user = useUserStore();
const tokens = ['CARBON', 'BIO'];
const tokenDescriptions = ref(['Carbon', 'Life']);

const claimableTokens = reactive<Tokens>([ZERO, ZERO]);
const resetSelectedClaiming = () => {
  if (claiming.selected > Number(ZERO)) {
    claimableTokens[claiming.selected] = ZERO;
  }
};
const claiming = reactive({
  visible: false,
  confirming: false,
  selected: NONE_SELECTED,
});
const resetClaiming = () => {
  claiming.visible = false;
  claiming.confirming = false;
  claiming.selected = NONE_SELECTED;
};
const claimed = reactive({
  visible: false,
});
const isZero = (value: string) => {
  return value === ZERO;
};
const claimToOwnedWallet = async () => {
  if (!smartContract.aggregator) return;

  const isClaimingSelectedEqual = (type: number) => type === claiming.selected;
  const isAllSelected = isClaimingSelectedEqual(ALL_SELECTED);
  const [carbonTokens, bioTokens] = ownedNFTs.value;
  const isCarbonClaimable =
    (isClaimingSelectedEqual(CARBON_SELECTED) || isAllSelected) &&
    !isZero(carbonTokens);
  const isBioClaimable =
    (isClaimingSelectedEqual(BIO_SELECTED) || isAllSelected) &&
    !isZero(bioTokens);
  if (!isClaimingSelectedEqual(NONE_SELECTED)) {
    const web3 = new Web3((window as any).ethereum);
    const gasPrice = await web3.eth.getGasPrice();

    return smartContract.aggregator.methods
      .claimTokens(isCarbonClaimable, isBioClaimable)
      .send({
        from: user.ethAddress as string,
        gasPrice,
      })
      .on('transactionHash', () => {
        claimed.visible = true;
        // is claim all
        if (isAllSelected) {
          ownedNFTs.value[0] = ZERO;
          ownedNFTs.value[1] = ZERO;
        } else {
          ownedNFTs.value[claiming.selected - 1] = ZERO;
        }
        resetSelectedClaiming();
        resetClaiming();
      });
  }
};
const isSelected = (options: number[]) => options.includes(claiming.selected);
const claimToGeneratedWallet = async () => {
  await apis.claimTokens({
    claimBio: isSelected([ALL_SELECTED, BIO_SELECTED]),
    claimCab: isSelected([ALL_SELECTED, CARBON_SELECTED]),
    sessionToken: user.sessionToken,
  });
  resetSelectedClaiming();
};
const confirmClaimToken = async () => {
  claiming.confirming = true;
  try {
    if (user.isGeneratedUser) {
      await claimToGeneratedWallet();
    } else {
      await claimToOwnedWallet();
    }
    await getClaimables(user.ethAddress as string);
  } catch (error) {
    showError(error);
  } finally {
    resetClaiming();
  }
};
const claimAllDisabled = computed(() => {
  return ownedNFTs.value.includes(ZERO);
});

const getClaimables = async (ethAddress: string) => {
  if (!smartContract.tokenGenerator) return;
  const { bioApproved, carbonApproved } = await moralis.Cloud.run(
    'getClaimableTokens',
    {
      address: ethAddress,
    }
  );
  const totalCarbonTokenClaimed = await smartContract.tokenGenerator.methods
    .totalCarbonTokenClaimed(ethAddress)
    .call({ from: ethAddress });
  const totalBioTokenClaimed = await smartContract.tokenGenerator.methods
    .totalBioTokenClaimed(ethAddress)
    .call({ from: ethAddress });
  const claimables = [
    carbonApproved - moralis.Units.FromWei(totalCarbonTokenClaimed, 18),
    bioApproved - moralis.Units.FromWei(totalBioTokenClaimed, 18),
  ];
  claimables.forEach((value, idx) => (claimableTokens[idx] = value));
};

const ownedNFTs = ref([ZERO, ZERO]);
const isMetamaskInstalled = computed(() => {
  if (typeof window.ethereum !== 'undefined') {
    return true;
  } else {
    return false;
  }
});
const getNFTs = async (ethAddress: string, tokenAddress: string) => {
  if (tokenAddress === CARBON_NFT_ADDRESS) {
    if (!isMetamaskInstalled.value) {
      const { data }: any = (await apis.getClaimTokens()) as Claimables;
      return data[0].total.toString();
    }
    const totalBioTokenClaimed = (await smartContract.aggregator?.methods
      .totalClaimableCarbonToken(ethAddress)
      .call({ from: ethAddress })) as string;
    const carbonClaimables = moralis.Units.FromWei(totalBioTokenClaimed, 18);
    return carbonClaimables;
  }

  if (tokenAddress === BIODIVERSITY_NFT_ADDRESS) {
    if (!isMetamaskInstalled.value) {
      const { data }: any = (await apis.getClaimTokens()) as Claimables;
      return data[1].total.toString();
    }
    const totalLifeTokenClaimed = (await smartContract.aggregator?.methods
      .totalClaimableLifeToken(ethAddress)
      .call({ from: ethAddress })) as string;
    const lifeClaimables = moralis.Units.FromWei(totalLifeTokenClaimed, 18);
    return lifeClaimables;
  }
};
const getOwnedNFTs = async (ethAddress: string) => {
  ownedNFTs.value = await Promise.all(
    [CARBON_NFT_ADDRESS, BIODIVERSITY_NFT_ADDRESS].map((nftAddress) =>
      getNFTs(ethAddress, nftAddress)
    )
  );
};

const onClaimAll = () => {
  claiming.visible = true;
  claiming.selected = ZERO;
};

watch(
  [smartContract, () => user.ethAddress],
  ([{ aggregator }, ethAddress]) => {
    if (!(aggregator && ethAddress)) return;
    // getClamingPeriods();
    getOwnedNFTs(ethAddress);
  },
  { immediate: true }
);
watch(
  [() => smartContract.tokenGenerator, () => user.ethAddress],
  ([tokenGenerator, ethAddress]) => {
    if (!(tokenGenerator && ethAddress)) return;
    getClaimables(ethAddress);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tokens, (token, idx) => {
        return _createVNode(_component_BaseBox, {
          key: token,
          "box-style": "raised",
          class: "flex items-center flex-wrap mb-6"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: require(`@/assets/svg/default-${token}.svg`),
                style: {"width":"80px"}
              }, null, 8, _hoisted_2)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(tokenDescriptions.value[idx]) + " Token ", 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(ownedNFTs.value[idx]) + " " + _toDisplayString(tokenDescriptions.value[idx]) + " Token ", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BaseButton, {
                full: "",
                "color-scheme": "primary",
                disabled: ownedNFTs.value[idx] == '0',
                class: "px-10",
                style: {"width":"166px"},
                onClick: 
            () => {
              _unref(claiming).visible = true;
              _unref(claiming).selected = idx + 1;
            }
          ,
                "data-testid": `receive-${idx}-btn`
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["disabled", "onClick", "data-testid"])
            ])
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_BaseButton, {
          "color-scheme": "primary",
          class: "px-12",
          disabled: _unref(claimAllDisabled),
          onClick: onClaimAll,
          "data-testid": "receive-all-btn"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", null, [
        _hoisted_13,
        _createVNode(_component_router_link, {
          to: "/landing/information-nfts",
          class: "text-blue-link"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", _hoisted_18, [
          _createVNode(IconFacebook)
        ]),
        _createElementVNode("a", _hoisted_19, [
          _createVNode(IconTwitter)
        ]),
        _createElementVNode("a", _hoisted_20, [
          _createVNode(IconYouTube)
        ]),
        _createElementVNode("a", _hoisted_21, [
          _createVNode(IconIg)
        ]),
        _createElementVNode("a", _hoisted_22, [
          _createVNode(IconTiktok)
        ])
      ])
    ]),
    _createVNode(_component_BaseModal, {
      modelValue: _unref(claiming).visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(claiming).visible) = $event)),
      "buttons-disabled": _unref(claiming).confirming,
      "modal-style": "confirm",
      onConfirm: confirmClaimToken
    }, {
      title: _withCtx(() => [
        _hoisted_23
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, _toDisplayString(tokenDescriptions.value[_unref(claiming).selected - 1] || 'All') + " tokens", 1),
          _hoisted_26
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "buttons-disabled"]),
    _createVNode(_component_BaseModal, {
      modelValue: _unref(claimed).visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(claimed).visible) = $event)),
      "cancel-text": false,
      "confirm-text": "Done",
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_unref(claimed).visible = false))
    }, {
      title: _withCtx(() => [
        _hoisted_27
      ]),
      default: _withCtx(() => [
        _hoisted_28
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})